var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav',{staticClass:"navbar-block"},[_c('div',{staticClass:"container h-100 d-flex align-items-center"},[_c('img',{attrs:{"width":"61","height":"38","src":"/images/nav-logo.svg","alt":"logo"}})])])])
}]

export { render, staticRenderFns }